import SETTINGS, { COLLES } from '../../../SETTINGS';
import { COLLA } from '../../../utils/utils';

// The colla's colour for the form's buttons and selections, as the app's store
// theme (readableAccent in mobileapp merxandatgeTheme.js): darkened until white
// text on it reads well. Aleta's green where the colla is unknown.
const FALLBACK = '#3b9975';

const channels = (color) => {
  const value = String(color || '').trim();
  const hex = value.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
  if (hex) {
    const digits = hex[1].length === 3 ? hex[1].replace(/./g, '$&$&') : hex[1];
    return [0, 2, 4].map((index) => parseInt(digits.slice(index, index + 2), 16));
  }
  const rgb = value.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
  return rgb ? rgb.slice(1, 4).map(Number) : null;
};

const luminance = (rgb) => {
  const [r, g, b] = rgb.map((channel) => {
    const value = channel / 255;
    return value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
const contrastWithWhite = (rgb) => 1.05 / (luminance(rgb) + 0.05);

export const readableAccent = (color) => {
  const base = channels(color) || channels(FALLBACK);
  let rgb = base;
  for (let amount = 1; amount <= 100 && contrastWithWhite(rgb) < 4.5; amount++) {
    rgb = base.map((channel) => Math.round(channel * (1 - amount / 100)));
  }
  return `rgb(${rgb.join(', ')})`;
};

export const collaAccent = (colla = COLLA) => readableAccent(COLLES.includes(colla) ? SETTINGS(colla).color : FALLBACK);
